var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import { connect } from 'react-redux';
import { relojSelectors } from '../selectors';
import * as actions from '../actions';
import Crono from './crono';

function mapStateToProps(state, ownProps) {
  var visible = relojSelectors.getVisible(state);
  var config = relojSelectors.getConfig(state);
  return _extends({
    visible: visible
  }, config);
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    onCerrar: function onCerrar() {
      return dispatch(actions.ocultarReloj());
    },
    onMover: function onMover(x, y) {
      return dispatch(actions.moverReloj(x, y));
    }
  };
}

var CronoContainer = connect(mapStateToProps, mapDispatchToProps)(Crono);
export default CronoContainer;